define('SageDotCom/DataLayer/Events/Forms/formSubmitError',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function FormSubmitErrorEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'form_submit_error'; // overwrite name
    }

    FormSubmitErrorEvent.prototype = Object.create(EventBase.prototype);

    FormSubmitErrorEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "0", //non interaction point
            "event_category": "contact", //top line category
            "event_action": "form submit", //specific action
            "release_date": "17th October 2024"
        }
        var eventDataGA4 = {
            "event": this.getName(), //event name
            "triggered_by": "sitecore"
        }
        if (scope) {
            var form = $(scope).closest('form');
            var location = this.getLocation(scope);
            var level5 = form.find('[data-sc-field-name="Level5"]');
            var modal = $(scope).closest(".modal");

            var progressBar;
            if (form.find(".product-trial-form").length > 0) {
                progressBar = $(".product-trial-header .progress-bar-holder");
            }
            else if (form.find(".privacy-rights-request-form").length > 0) {
                progressBar = $(".score-style-box.privacy-rights-request .progress-bar-holder");
            }
            else {
                progressBar = form.siblings(".progress-bar-holder");
            }

            var errorMessage = "";
            var elementsWithError = "";
            var errorElem = form.find(".input-validation-error");
            var spans = form.find(".field-validation-error span");

            if (errorElem.length > 0 && spans.length > 0) {
                var coma = "";
                $(errorElem).each(function (index) {
                    if (index > 0) {
                        coma = ", ";
                    }
                    var fieldNameInError = errorElem[index].getAttribute("data-sc-field-name");
                    if (elementsWithError.indexOf(fieldNameInError) < 0) {
                        elementsWithError = elementsWithError + coma + fieldNameInError;
                    }
                    var textContent = "";
                    if (spans && index < spans.length) {
                        textContent = spans[index].textContent;
                        errorMessage = errorMessage + coma + textContent;
                    }
                });
            }

            eventData = $.extend(eventData, {
                'event_label': "unsuccessful",
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': form.attr('id'),
                'event_name_level_3': "(not set)",
                'event_name_level_4': location,
                'event_name_level_5': level5.length > 0 ? level5[0].defaultValue : "(not set)",
                'error_code': "",
                'error_message': errorMessage,
                'form_elements_with_error': elementsWithError,
            });
            eventDataGA4 = $.extend(eventDataGA4, {
                "gate_content_name": level5.length > 0 ? level5[0].defaultValue : "(not set)",
                "form_step": progressBar.length > 0 ? parseInt(progressBar.find("li .progress-bar-current .progress-bar-index")[0].textContent) : 1,
                "total_steps": progressBar.length > 0 ? progressBar.find("li").length : 1,
                "form_type": progressBar.length > 0 ? "multistep" : "normal",
                "form_id": form.attr('id'),
                "display_method": modal.length > 0 ? "modal" : "inline"
            });
        }
        eventData = $.extend(eventData, eventDataGA4);
        return eventData;
    }

    return new FormSubmitErrorEvent();
});
